// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App.vue'
import router from './router'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import vueSwiper from 'vue-awesome-swiper';
import 'swiper/dist/css/swiper.css';

import {recordPageViews} from './request/api.js';


import Affix from 'easy-affix';
//柱状图
// import VeHistogram from 'v-charts/lib/histogram.common'
// Vue.component(VeHistogram.name, VeHistogram)

// import VCharts from 'v-charts-v2'
// Vue.use(VCharts)

Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.use(vueSwiper);
Vue.component('affix', Affix)
/* eslint-disable no-new */

// 图片预览插件
// import hevueImgPreview from 'hevue-img-preview'
// Vue.use(hevueImgPreview, {
//   keyboard: true,
//   clickMaskCLose: true
// })

router.beforeEach((to, from, next) => {
	// jlb_pdflist jlb_manualdata jlb_jiancepdf 与其他路由统计重复，需要排除
	if(to.name != 'jlb_pdflist' && to.name != 'jlb_manualdata' && to.name != 'jlb_jiancepdf') {
		// 记录页面访问
		let param = {
			// url: to.name,
			title: to.meta.title
		}
		recordPageViews(param);
	}
	
	
	
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next();
})
new Vue({
  el: '#app',
  render: h => h(App),
  router,
  components: { App },
  template: '<App/>'
})

Vue.directive('title', {

    inserted: (el, binding) => {

      document.title = binding.value;

    }

  })





// WEBPACK FOOTER //
// ./src/main.js